"use client";

import { cn } from "@/lib/utils";

interface ErrorMessageProps {
  message: string | null;
  className?: string;
}

/**
 * Shared inline error display. Renders nothing when message is null or empty.
 * Use with getErrorMessage() for consistent, RFC 9457-aware error text.
 */
export function ErrorMessage({ message, className }: ErrorMessageProps) {
  if (message == null || message.trim() === "") return null;
  return (
    <div
      role="alert"
      className={cn(
        "bg-destructive/10 text-destructive p-3 rounded-md text-sm",
        className
      )}
    >
      {message}
    </div>
  );
}
